import { render, staticRenderFns } from "./cabinetInformation.vue?vue&type=template&id=5d32e84a&scoped=true"
import script from "./cabinetInformation.vue?vue&type=script&lang=js"
export * from "./cabinetInformation.vue?vue&type=script&lang=js"
import style0 from "./cabinetInformation.vue?vue&type=style&index=0&id=5d32e84a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d32e84a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d32e84a')) {
      api.createRecord('5d32e84a', component.options)
    } else {
      api.reload('5d32e84a', component.options)
    }
    module.hot.accept("./cabinetInformation.vue?vue&type=template&id=5d32e84a&scoped=true", function () {
      api.rerender('5d32e84a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/smartCabinet/cabinetInformation.vue"
export default component.exports